<div *ngIf="!isSummaryMode && taskCreationMode !== TaskCreationMode.EDIT" class="forms-selection-header-container">
    <div class="forms-selection-header">
        <div class="title-with-text-action">
            <div class="title">{{ 'ToDos.CreateTask.RequiredForms' | translate }}</div>
            <gsp-button
                *ngIf="!layerIdsInOrder.length"
                [type]="ButtonType.TextIcon"
                [iconClass]="'icon_line_plus_blue_24 i24'"
                (action)="emitAddVisibleFormsToSelection()"
                text="{{ 'TC.Common.AddAllVisibleForms' | translate }}"
                class="button-text-action"
            ></gsp-button>
            <gsp-button
                *ngIf="layerIdsInOrder.length"
                [type]="ButtonType.TextIcon"
                [iconClass]="'text-button-no-icon'"
                (action)="clearAllFormSelection()"
                text="{{ 'MapViewer_Generic_RemoveSelection' | translate }}"
                class="button-text-action"
            ></gsp-button>
        </div>
    </div>
    <div class="forms-selection-description">
        <span>{{ 'Select forms from the map in order to add them to this task' }}</span>
    </div>
    <div *ngIf="!layerIdsInOrder.length" class="info-message-rectangle no-forms-info">
        {{ 'TC.ToDos.NoFormsSelected' | translate }}
    </div>
    <gsp-notification *ngIf="isNonTemplatedFeaturesExcluded && !isSummaryMode" [type]="NotificationType.Warning">
        <div>
            {{ 'TCS.Todo.Todo.NontemplatedFeaturesExcluded' | translate }}
        </div>
    </gsp-notification>
</div>

<div class="forms-selection-body" [ngClass]="{ 'form-selection-summary-mode': isSummaryMode }">
    <custom-scroll *ngIf="taskCreationMode !== TaskCreationMode.NEW" class="forms-selection-list">
        <ng-container *ngTemplateOutlet="layerFeaturesListTemplate"></ng-container>
    </custom-scroll>
    <ng-container *ngIf="taskCreationMode === TaskCreationMode.NEW">
        <ng-container *ngTemplateOutlet="layerFeaturesListTemplate"></ng-container>
    </ng-container>
    <ng-template #layerFeaturesListTemplate>
        <div *ngFor="let layerId of layerIdsInOrder; let layerIndex = index" class="forms-selection-list-layer">
            <ul class="forms-selection-list-layer-forms">
                <div
                    [ngClass]="{ open: openAccordionIndices.includes(layerIndex) }"
                    class="forms-selection-list-layer-forms-header"
                    (click)="toggleAccordion(layerIndex)"
                >
                    <geom-icon
                        [path]="'symbol_24-preview-'"
                        [color]="'#' + featuresByLayerId(layerId)[0]?.colorKey"
                        [geoType]="featuresByLayerId(layerId)[0]?.geometryType"
                        [outlineColor]="
                            getLayerOutlineColorFromStyle(
                                featuresByLayerId(layerId)[0]?.style,
                                featuresByLayerId(layerId)[0]?.geometryType,
                                '#' + featuresByLayerId(layerId)[0]?.colorKey
                            )
                        "
                        [svgIcon]="featuresByLayerId(layerId)[0]?.style.symbol?.svgImage"
                        [symbolType]="featuresByLayerId(layerId)[0]?.style.symbol?.type"
                        [symbolText]="featuresByLayerId(layerId)[0]?.style.symbol?.text"
                        [lineStyle]="featuresByLayerId(layerId)[0]?.style.lineStyle"
                        [polygonOpacity]="featuresByLayerId(layerId)[0]?.style.fillOpacity"
                    ></geom-icon>
                    <h3>{{ featuresByLayerId(layerId)[0]?.layerName }}</h3>
                    <span>
                        {{
                            'TC.ToDosTasks.Forms' | translate: { count: featuresByLayerId(layerId).length } | lowercase
                        }}
                    </span>
                    <i *ngIf="!isSummaryMode" class="i24 icon_line_chevron_left"></i>
                </div>
                <gsp-notification
                    *ngIf="
                        !previewFieldsByFeatureId(featuresByLayerId(layerId)[0]?.id) &&
                        openAccordionIndices.includes(layerIndex)
                    "
                    [type]="NotificationType.Warning"
                >
                    <div>
                        {{ 'TC.TodosTasks.PreviewFieldReminder' | translate }}
                    </div>
                </gsp-notification>
                <div
                    *ngIf="!isSummaryMode"
                    [ngClass]="{ open: openAccordionIndices.includes(layerIndex) }"
                    class="forms-selection-list-layer-forms-preview"
                >
                    <div
                        *ngFor="let feature of featuresByLayerId(layerId)"
                        class="forms-selection-list-layer-forms-preview-item"
                    >
                        <div class="forms-preview-field">
                            <ng-container *ngIf="previewFieldsByFeatureId(feature.id) as preview">
                                <ul class="preview-field-list">
                                    <li *ngIf="preview.previewField1">
                                        {{ preview.previewField1?.value }}
                                    </li>
                                    <li *ngIf="preview.previewField2">
                                        {{ preview.previewField2?.value }}
                                    </li>
                                </ul>
                            </ng-container>
                        </div>

                        <div class="image-and-remove-wrapper">
                            <div
                                *ngIf="previewFieldsByFeatureId(feature.id)?.thumbnailField?.value"
                                class="forms-preview-thumbnail"
                            >
                                <image-field
                                    class="forms-preview-thumbnail-image"
                                    [field]="previewFieldsByFeatureId(feature.id).thumbnailField"
                                    [galleryRef]="feature.id"
                                    [hideFieldLabel]="true"
                                ></image-field>
                            </div>
                            <!-- TerraFlex won't reflect change in forms as of now. Hiding X button until futher decision is made. -->
                            <!-- <div class="forms-preview-remove">
                                <gsp-button
                                    [type]="ButtonType.Icon"
                                    [iconClass]="'icon_line_close_24 i24'"
                                    (click)="removeFormFromSelection(feature.id, layerId)"
                                ></gsp-button>
                            </div> -->
                        </div>
                    </div>
                </div>
            </ul>
        </div>
    </ng-template>
</div>
